<script>
import ClientesService from '@/services/clientes.service';
import { PaginacionDefault, Rol, ESTADO_CONTADOR, ESTADO_REGISTRO_CONTADOR, EstadoContador, RegistroEstadoContador } from '@/constants/global';
import Utils from '@/functions/utils';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      roles: Rol,
      asesores: [],
      estados: ESTADO_CONTADOR,
      registros: ESTADO_REGISTRO_CONTADOR,
      errores: {},
      asesorCurrent: {},
      usuario: authService.getUser(),
      contador: {
        asesor: -1,
        documento: null,
        nombre: null,
        estado: EstadoContador.PENDIENTE,
        confirmacion: RegistroEstadoContador.PENDIENTE
      }
    }
  },
  mounted() {
    this.getUsuarios();

  },
  methods: {
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
      this.asesorCurrent = this.asesores.find(fnd => fnd.value == this.usuario.idUsuario);
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idasesor = Rol.ADMINISTRADOR == this.usuario.rol
        && (this.contador.asesor == null || this.contador.asesor == -1);
      this.errores.documento = this.contador.documento == null || this.contador.documento.trim() == '';
      this.errores.nombre = this.contador.nombre == null || this.contador.nombre.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;
      
      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          IdAsesor: this.contador.asesor,
          Documento: this.contador.documento,
          RazonSocial: this.contador.nombre,
          Estado: this.contador.estado,
          Confirmacion: this.contador.confirmacion,
          Ocupacion: 'Contador',
          FechaCreacion: new Date()
        };

        await ClientesService.createContador(obj);
        Utils.mostrarMensajeExito('El contador se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/info/contadores`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>NUEVO CONTADOR SMART</h1>
            <p>REGISTRE LOS DATOS DEL NUEVO CONTADOR</p>
          </div>
          <div class="card-body p-5">
            <form>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="asesor" class="form-control-lg">Asesor de Ventas</label>
                  </div>
                  <div class="col-sm-7">
                    <select v-if="usuario.rol == roles.ADMINISTRADOR" name="cont_asesor" id="cont_asesor"
                      class="req form-select form-control-lg" v-model="contador.asesor"
                      v-bind:class="{ 'invalid': errores.idasesor }">
                      <option value="-1">Seleccione un asesor</option>
                      <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                        {{ asesor.label }}
                      </option>
                    </select>
                    <template v-else>
                      <input type="text" class="form-control form-control-lg" :value="asesorCurrent.label" disabled
                        v-bind:class="{ 'invalid': errores.idasesor }">
                      <input type="hidden" name="cont_asesor" id="cont_asesor" class="form-control form-control-lg"
                        :value="asesorCurrent.value">
                    </template>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del contador SMART</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="cont_dni" class="form-control-lg">DNI</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_dni" id="cont_dni"
                      maxlength="11" v-model="contador.documento" v-bind:class="{ 'invalid': errores.documento }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_nombre" id="cont_nombre"
                      maxlength="255" v-model="contador.nombre" v-bind:class="{ 'invalid': errores.nombre }">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Estado del registro</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="estado" class="form-control-lg">Estado</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_estado" id="cont_estado" class="form-select form-control-lg"
                      v-model="contador.estado" disabled>
                      <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="confirmacion" class="form-control-lg">Confirmación de registro</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_registro" id="cont_registro" class="form-select form-control-lg"
                      v-model="contador.confirmacion" disabled>
                      <option v-for="registro in registros" :key="registro.id" :value="registro.id">
                        {{ registro.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cont_ocupacion" id="cont_ocupacion" value="Contador">
                  <input type="hidden" name="cont_fec_creacion" id="cont_fec_creacion">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a>
                  </div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>